module.exports = __webpack_public_path__ + "img/boss-gmbh-logo.fd51f324.jpg";